import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
// import IconButton from "@mui/material/IconButton";
// import Tooltip from "@mui/material/Tooltip";
// import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Layout from "../../Layout";
import Loader from "../../Layout/Loader";
import TextField from "../../Components/common/TextField";
import Button from "../../Components/common/Button";
import MenuItem from "../../Components/common/MenuItem";
import EmptyState from "../../Components/common/EmptyState";
import PmsPageFilters from "../../Components/common/PmsPageFilters";
import VehicleCategoryModal from "../../Components/Vehicles/VehicleCategoryModal";
import instance from "../../axios";
import { checkPrivileges, errorHandler } from "../../Helpers";
import { notifySuccess } from "../../Utils/CustomNotifcations";
import withTranslationWrapper from "../../HOC/withTranslation";

const CancelToken = axios.CancelToken;
let source = "";

const defaultForm = {
  category: "",
  fleetType: "",
  baselineInterval: "",
  baselineIntervalDays: "",
};

const buildRecordPayload = (record, active) => ({
  ...record,
  attributes: record.attributes || {},
  active,
});

class UserPms extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initFetch: false,
      listLoader: false,
      formLoader: false,
      submitLoader: false,
      statusUpdateId: null,
      searchText: "",
      activeFilter: 2,
      plateNo: "",
      category: "",
      itemCode: "",
      completed: "2",
      mode: "",
      pmsForm: { ...defaultForm },
      pmsRecord: null,
      isVisableSubmitBtn: true,
      initialFetch: true,
      currentPage: 1,
      pageSize: 50,
      itemPagination: {
        items: [],
        total: 0,
        hasNext: false,
      },
      categoriesList: [],
      categoryModalOpen: false,
    };
  }

  componentWillMount() {
    this.fetchCategories();
    if (
      this.props.logInUser &&
      this.props.logInUser.id &&
      this.state.initFetch === false
    ) {
      this.setState({ initFetch: true }, () => {
        this.fetchData(1, this.state.pageSize);
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.logInUser &&
      nextProps.logInUser.id &&
      this.state.initFetch === false
    ) {
      this.setState({ initFetch: true }, () => {
        this.fetchData(1, this.state.pageSize);
      });
    }
  }

  fetchCategories = () => {
    instance(`/api/vehiclecategorys/get?page=1&limit=500&category=`)
      .then((response) => {
        const categories = [
          ...new Set(
            (response?.data || [])
              .map((item) => item?.categoryName)
              .filter(Boolean),
          ),
        ];
        this.setState((prevState) => {
          const formFleetType = prevState.pmsForm?.fleetType;
          const resolvedFleetType = this.resolveFleetType(
            formFleetType,
            categories,
          );
          return {
            categoriesList: categories,
            pmsForm:
              prevState.pmsForm && resolvedFleetType
                ? { ...prevState.pmsForm, fleetType: resolvedFleetType }
                : prevState.pmsForm,
          };
        });
      })
      .catch((error) => {
        errorHandler(error, this.props.dispatch);
      });
  };

  resolveFleetType = (
    apiFleetType,
    categoriesList = this.state.categoriesList,
  ) => {
    if (!apiFleetType) return "";
    if (!categoriesList?.length) return apiFleetType;
    const match = categoriesList.find(
      (option) =>
        String(option).toLowerCase() === String(apiFleetType).toLowerCase(),
    );
    return match || apiFleetType;
  };

  componentWillUnmount() {
    if (source) {
      source.cancel();
    }
  }

  fetchData = (page, perPage, pagination = false, reset = false) => {
    if (source) {
      source.cancel();
    }
    source = CancelToken.source();
    let items = this.state.itemPagination.items;
    if (reset) {
      items = [];
    }

    const { searchText, activeFilter, plateNo, category, itemCode, completed } =
      this.state;
    const params = new URLSearchParams({
      page: String(page),
      limit: String(perPage),
      active: String(activeFilter),
    });
    if (searchText?.trim()) {
      params.set("search", searchText.trim());
    }
    if (plateNo?.trim()) {
      params.set("plateNo", plateNo.trim());
    }
    if (category?.trim()) {
      params.set("category", category.trim());
    }
    if (itemCode?.trim()) {
      params.set("itemCode", itemCode.trim());
    }
    if (completed !== "" && completed != null) {
      params.set("completed", completed);
    }

    this.setState({ listLoader: true });

    instance({
      url: `/api/userpmsintervals/get?${params.toString()}`,
      method: "GET",
      cancelToken: source.token,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        const rows = res.data || [];
        const nextItems = pagination ? items.concat(rows) : rows;
        this.setState(
          {
            listLoader: false,
            itemPagination: {
              items: nextItems,
              total: res.total || 0,
              hasNext: res.hasNext || false,
            },
            currentPage: res.hasNext
              ? (res.page || page) + 1
              : res.page || page,
          },
          () => {
            if (this.state.initialFetch && nextItems.length) {
              this.openEditForm(nextItems[0]);
              this.setState({ initialFetch: false });
            }
          },
        );
      })
      .catch((error) => {
        if (!axios.isCancel(error)) {
          this.setState({ listLoader: false });
          errorHandler(error, this.props.dispatch);
        }
      });
  };

  fetchMoreItems = () => {
    this.fetchData(this.state.currentPage, this.state.pageSize, true);
  };

  searchItems = (text) => {
    this.setState(
      { searchText: text, initialFetch: false, currentPage: 1 },
      () => this.fetchData(1, this.state.pageSize, false, true),
    );
  };

  onActiveFilterChange = (value) => {
    this.setState(
      {
        activeFilter: parseInt(value, 10),
        initialFetch: false,
        currentPage: 1,
      },
      () => this.fetchData(1, this.state.pageSize, false, true),
    );
  };

  handlePageFilterChange = (name, value) => {
    this.setState({ [name]: value });
  };

  applyPageFilters = () => {
    this.setState({ initialFetch: false, currentPage: 1 }, () =>
      this.fetchData(1, this.state.pageSize, false, true),
    );
  };

  clearPageFilters = () => {
    this.setState(
      {
        plateNo: "",
        category: "",
        itemCode: "",
        completed: "2",
        initialFetch: false,
        currentPage: 1,
      },
      () => this.fetchData(1, this.state.pageSize, false, true),
    );
  };

  openCreateForm = () => {
    this.setState(
      {
        mode: "create",
        pmsForm: { ...defaultForm },
        pmsRecord: null,
        initialFetch: false,
      },
      () => this.checkRequiredFields(),
    );
  };

  openEditForm = (item) => {
    if (!item?.id) {
      return;
    }
    this.setState({
      mode: "",
      pmsForm: { ...defaultForm },
      pmsRecord: null,
      formLoader: true,
      initialFetch: false,
    });
    instance({
      url: `/api/userpmsintervals/${item.id}`,
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        this.setState(
          {
            mode: "edit",
            formLoader: false,
            pmsRecord: res,
            pmsForm: {
              id: res.id,
              userId: res.userId,
              category: res.category || "",
              fleetType: this.resolveFleetType(res.fleetType || ""),
              baselineInterval: res.baselineInterval ?? "",
              baselineIntervalDays: res.baselineIntervalDays ?? "",
              archive: res.archive || false,
              attributes: res.attributes || {},
              active: res.active !== false,
            },
          },
          () => this.checkRequiredFields(),
        );
      })
      .catch((error) => {
        this.setState({ formLoader: false });
        errorHandler(error, this.props.dispatch);
      });
  };

  closeForm = () => {
    this.setState({
      mode: "",
      pmsForm: { ...defaultForm },
      pmsRecord: null,
      isVisableSubmitBtn: true,
    });
  };

  updateItemStatus = (item, active) => {
    if (!item?.id) {
      return Promise.resolve();
    }

    this.setState({ statusUpdateId: item.id });

    return instance({
      url: `/api/userpmsintervals/${item.id}`,
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) =>
        instance({
          url: `/api/userpmsintervals/${item.id}`,
          method: "PUT",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          data: buildRecordPayload(res, active),
        }),
      )
      .then(() => {
        this.props.dispatch(notifySuccess("userPmsStatusUpdated"));
        if (parseInt(this.state.pmsForm?.id, 10) === parseInt(item.id, 10)) {
          this.setState((prevState) => ({
            pmsForm: {
              ...prevState.pmsForm,
              active,
            },
          }));
        }
        this.fetchData(1, this.state.pageSize, false, true);
      })
      .catch((error) => {
        errorHandler(error, this.props.dispatch);
      })
      .finally(() => {
        this.setState({ statusUpdateId: null });
      });
  };

  deleteItem = (id) => {
    instance({
      url: `/api/userpmsintervals/${id}`,
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then(() => {
        this.props.dispatch(notifySuccess("userPmsDeleted"));
        if (this.state.pmsForm?.id === id) {
          this.closeForm();
        }
        this.fetchData(1, this.state.pageSize, false, true);
      })
      .catch((error) => {
        errorHandler(error, this.props.dispatch);
      });
  };

  handleChange = (name, value) => {
    this.setState(
      {
        pmsForm: {
          ...this.state.pmsForm,
          [name]: value,
        },
      },
      () => this.checkRequiredFields(),
    );
  };

  checkRequiredFields = () => {
    const { category, fleetType, baselineInterval, baselineIntervalDays } =
      this.state.pmsForm;
    const interval = parseInt(baselineInterval, 10);
    const intervalDays = parseInt(baselineIntervalDays, 10);
    const isValid =
      category &&
      category.trim() &&
      fleetType &&
      baselineInterval !== "" &&
      baselineInterval !== null &&
      !Number.isNaN(interval) &&
      interval >= 0 &&
      baselineIntervalDays !== "" &&
      baselineIntervalDays !== null &&
      !Number.isNaN(intervalDays) &&
      intervalDays >= 0;

    this.setState({
      isVisableSubmitBtn: !isValid,
    });
  };

  buildPayload = () => {
    const { pmsForm, mode, pmsRecord } = this.state;
    const formFields = {
      category: pmsForm.category.trim(),
      fleetType: pmsForm.fleetType,
      baselineInterval: parseInt(pmsForm.baselineInterval, 10),
      baselineIntervalDays: parseInt(pmsForm.baselineIntervalDays, 10),
      attributes: {},
      archive: mode === "edit" ? Boolean(pmsForm.archive) : false,
      archiveTime: mode === "edit" ? (pmsRecord?.archiveTime ?? null) : null,
      active: mode === "edit" ? pmsForm.active !== false : true,
    };

    if (mode === "edit" && pmsRecord) {
      return {
        ...pmsRecord,
        ...formFields,
        id: pmsForm.id,
      };
    }

    return formFields;
  };

  submitForm = () => {
    const { mode, pmsForm } = this.state;
    const payload = this.buildPayload();
    const isEdit = mode === "edit";
    const url = isEdit
      ? `/api/userpmsintervals/${pmsForm.id}`
      : "/api/userpmsintervals";

    this.setState({ submitLoader: true, isVisableSubmitBtn: true });

    instance({
      url,
      method: isEdit ? "PUT" : "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      data: payload,
    })
      .then((res) => {
        this.setState({ submitLoader: false });
        this.props.dispatch(
          notifySuccess(isEdit ? "userPmsUpdated" : "userPmsCreated"),
        );
        this.fetchData(1, this.state.pageSize, false, true);
        if (isEdit) {
          this.openEditForm({ id: pmsForm.id });
        } else if (res?.id) {
          this.openEditForm({ id: res.id });
        } else {
          this.closeForm();
        }
      })
      .catch((error) => {
        this.setState({ submitLoader: false });
        errorHandler(error, this.props.dispatch);
        this.checkRequiredFields();
      });
  };

  render() {
    if (!checkPrivileges("aiPms")) {
      return null;
    }

    const { itemPagination, mode, pmsForm, formLoader, submitLoader } =
      this.state;
    const endMessage =
      itemPagination && itemPagination.total > 0 ? (
        <p style={{ textAlign: "center", color: "#ccc" }}>
          -- {this.props.translate("end")} --
        </p>
      ) : (
        <p style={{ textAlign: "center", color: "#ccc" }}>
          {this.props.translate("notFound")}
        </p>
      );

    return (
      <Layout
        {...this.props}
        endMessage={endMessage}
        openCreateForm={this.openCreateForm}
        openEditForm={this.openEditForm}
        deleteItem={this.deleteItem}
        updateItemStatus={this.updateItemStatus}
        statusUpdateId={this.state.statusUpdateId}
        searchItems={this.searchItems}
        onActiveFilterChange={this.onActiveFilterChange}
        searchText={this.state.searchText}
        activeFilter={this.state.activeFilter}
        fetchMoreItems={this.fetchMoreItems}
        pmsForm={pmsForm}
        listLoader={this.state.listLoader}
        {...this.state}
      >
        <div className="main-content-page">
          <div
            style={{
              background: this.props.themecolors.backgroundColor,
              color: this.props.themecolors.textColor,
              borderRadius: 6,
            }}
          >
            <PmsPageFilters
              values={{
                plateNo: this.state.plateNo,
                category: this.state.category,
                itemCode: this.state.itemCode,
                completed: this.state.completed,
              }}
              onChange={this.handlePageFilterChange}
              onSubmit={this.applyPageFilters}
              onClear={this.clearPageFilters}
              translate={this.props.translate}
            />
            <div style={{ padding: 16, paddingTop: 0 }}>
              {formLoader ? (
                <Loader />
              ) : mode === "create" || mode === "edit" ? (
                <UserPmsForm
                  form={pmsForm}
                  mode={mode}
                  translate={this.props.translate}
                  handleChange={this.handleChange}
                  submitForm={this.submitForm}
                  closeForm={this.closeForm}
                  isVisableSubmitBtn={this.state.isVisableSubmitBtn}
                  submitLoader={submitLoader}
                  categoriesList={this.state.categoriesList}
                  openCategoryModal={() =>
                    this.setState({ categoryModalOpen: true })
                  }
                />
              ) : (
                <EmptyState text={this.props.translate("noUserPmsSelected")} />
              )}
            </div>
          </div>
        </div>
        {this.state.categoryModalOpen && (
          <VehicleCategoryModal
            onClose={() => this.setState({ categoryModalOpen: false })}
            onCategoriesUpdated={this.fetchCategories}
            translate={this.props.translate}
          />
        )}
      </Layout>
    );
  }
}

const UserPmsForm = ({
  form,
  mode,
  translate,
  handleChange,
  submitForm,
  closeForm,
  isVisableSubmitBtn,
  submitLoader,
  categoriesList = [],
  openCategoryModal,
}) => (
  <div>
    <h4 className="page-title">
      {mode === "edit"
        ? `${translate("update")} ${translate("userPms")}`
        : `${translate("sharedCreate")} ${translate("userPms")}`}
    </h4>
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          id="category"
          required
          margin="dense"
          label={translate("category")}
          variant="outlined"
          fullWidth
          value={form.category || ""}
          onChange={(e) => handleChange("category", e.target.value)}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Box display="flex" alignItems="flex-start" gap={0.5}>
          <TextField
            id="fleetType"
            required
            margin="dense"
            label={translate("vehicleType")}
            variant="outlined"
            fullWidth
            select
            style={{ flex: 1 }}
            value={form.fleetType || ""}
            onChange={(e) => handleChange("fleetType", e.target.value)}
          >
            <MenuItem value={0}>
              <em>{translate("none")}</em>
            </MenuItem>
            {(Array.isArray(categoriesList) ? categoriesList : []).map(
              (option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ),
            )}
          </TextField>
          {/* <Tooltip title={translate("manageVehicleTypes")}>
            <IconButton
              size="small"
              color="primary"
              onClick={openCategoryModal}
              style={{ marginTop: 8 }}
              aria-label={translate("manageVehicleTypes")}
            >
              <AddCircleOutlineIcon />
            </IconButton>
          </Tooltip>
          */}
        </Box>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          id="baselineInterval"
          required
          margin="dense"
          label={translate("baselineInterval")}
          variant="outlined"
          fullWidth
          type="number"
          inputProps={{ min: 0 }}
          value={form.baselineInterval ?? ""}
          onChange={(e) => handleChange("baselineInterval", e.target.value)}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          id="baselineIntervalDays"
          required
          margin="dense"
          label={translate("baselineIntervalDays")}
          variant="outlined"
          fullWidth
          type="number"
          inputProps={{ min: 0 }}
          value={form.baselineIntervalDays ?? ""}
          onChange={(e) => handleChange("baselineIntervalDays", e.target.value)}
        />
      </Grid>
    </Grid>
    <div
      style={{ display: "flex", marginTop: 16, alignItems: "center", gap: 12 }}
    >
      <Button
        size="small"
        className="button-white"
        onClick={closeForm}
        disabled={submitLoader}
      >
        {translate("sharedCancel")}
      </Button>
      <Button
        size="small"
        onClick={submitForm}
        disabled={isVisableSubmitBtn || submitLoader}
      >
        {translate(mode === "edit" ? "update" : "sharedCreate")}
      </Button>
    </div>
  </div>
);

const mapStateToProps = (state) => ({
  themecolors: state.themeColors,
  logInUser: state.logInUsers,
});

export default connect(mapStateToProps)(withTranslationWrapper(UserPms));
